/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import Breadcrumb from '../../components/Label/Breadcrumb'
import { Formik } from 'formik'
import { CreateStockOpnamePackingSchema } from '../../utils/validationSchema'
import TextField from '../../components/Input/TextInput'
import RowEmpty from '../../components/atoms/RowEmpty'
import api from '../../config/AxiosInstance'
import { BadgeStatusCOA } from '../../components/atoms/StatusLabel'
import Loading from '../../components/atoms/Loading'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import { ClipboardList, Warehouse } from 'lucide-react'

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const valueDetailStyle = {
  fontSize: '1rem',
  fontWeight: '600',
  color: '#333333',
  marginBottom: '0'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

function StockOpnamePackingDetail() {
  const { state } = useLocation()
  const { id } = useParams()
  const navigate = useNavigate()
  const formikRef = useRef(null)
  const [visible, setVisible] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState({
    page: false,
    submit: false,
    download: false
  })
  const columns = [
    { key: 'sequence', label: 'No' },
    { key: 'item_name', label: 'Item' },
    { key: 'total_pack', label: 'Pack (System)', className: 'text-end' },
    { key: 'checked_pack', label: 'Checked', className: 'text-end' },
    {
      key: 'status',
      label: 'Status',
      className: 'text-end',
      component: (item) =>
        ['', null, undefined].includes(item?.status) ? (
          ''
        ) : (
          <BadgeStatusCOA text={item.status || 'not_match'} />
        )
    }
  ]
  const handleSubmit = async (values) => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, submit: true }))
      const res = await api.post('/opname-packing', values)
      const { data } = res.data
      if (data) {
        let message = 'Stock Opname Saving'
        if (isSubmit) {
          message = 'Stock Opname submitted'
        }
        toast.success(message, {
          position: 'top-right',
          style: { fontSize: '14px', fontWeight: '600' }
        })
        navigate('/stock-opname/packing-stock-opname', {
          state: {
            warehouse_id: state?.warehouse_id
          }
        })
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, submit: false }))
      if (isSubmit) {
        setVisible(false)
        setIsSubmit(false)
      }
    }
  }
  const fetchData = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, page: true }))
      const res = await api.get(`/opname-packing/${id}`)
      const { data } = res.data
      if (data) {
        setData(data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      navigate('/stock-opname/packing-stock-opname', {
        state: {
          warehouse_id: state?.warehouse_id
        }
      })
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, page: false }))
    }
  }
  const handleDownload = async () => {
    try {
      setLoading((prev) => ({ ...prev, download: true }))
      const res = await api.get(`/opname-packing/${id}`, {
        params: {
          download: true
        }
      })
      const { status, data: dataResponse } = res
      if (status === 200) {
        const blob = new Blob([dataResponse], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-stock-opname-${data?.code}`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    } finally {
      setLoading((prev) => ({ ...prev, download: false }))
    }
  }
  const handleCloseModal = () => {
    setVisible(false)
    setIsSubmit(false)
  }
  useEffect(() => {
    fetchData()
  }, [id])

  if (loading.page) {
    return <Loading />
  }
  return (
    <Container fluid className="px-4 mb-5">
      <Toaster />
      <Row>
        <Col md={6} className="mt-3 mb-4">
          <Breadcrumb
            label={data?.code || ''}
            labelSub="OPNAME DETAIL"
            link="/stock-opname/packing-stock-opname"
            back="PACKING STOCK OPNAME"
            status={data?.status || 'finished'}
            type="BadgeStatusPrList"
            stateValue={{
              warehouse_id: state?.warehouse_id
            }}
          />
        </Col>
        <Col md={6} className="text-end mt-3 mb-4">
          <div className="d-flex align-items-baseline mt-1 justify-content-end h-100">
            <Button
              variant="transparent"
              className={`${
                loading.download
                  ? 'btn-secondary opacity-25'
                  : 'btn-primary-orange'
              } mb-0`}
              style={{ height: '37px' }}
              disabled={loading.download}
              onClick={handleDownload}
            >
              {loading.download ? 'Downloading...' : 'Download Stock Opname'}
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Formik
          innerRef={formikRef}
          initialValues={{
            type: 'update',
            warehouse_id: data?.warehouse_id || '',
            warehouse_name: data?.warehouse || '',
            notes: data?.notes || '',
            opname_id: data?.opname_id || '',
            items: data?.items || []
          }}
          validateOnChange={true}
          validationSchema={CreateStockOpnamePackingSchema}
          onSubmit={(values) => {
            values.is_submited = isSubmit
            values.items = values?.items?.map((item) => {
              return {
                ...item,
                checked_pack: !item.checked_pack ? null : item.checked_pack
              }
            })
            const { type, warehouse_name, ...dataValues } = values
            handleSubmit(dataValues)
          }}
          enableReinitialize={true}
          initialTouched={{
            type: true,
            warehouse_id: true,
            warehouse_name: true,
            notes: true,
            opname_id: true,
            items:
              data?.items?.map(() => ({
                id: true,
                item_id: true,
                item_name: true,
                total_pack: true,
                checked_pack: true,
                status: true
              })) || []
          }}
          validateOnMount={true}
        >
          {({
            handleBlur,
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            isValid,
            dirty,
            setFieldValue
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                {/* Header Info Card */}
                <Card style={cardStyle} className="mb-4">
                  <Row className="gy-4">
                    <Col xs={12} md={6}>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded bg-light d-flex align-items-center justify-content-center me-3"
                          style={{ width: '48px', height: '48px' }}
                        >
                          <Warehouse size={20} className="text-secondary" />
                        </div>
                        <div>
                          <div style={labelDetailStyle}>WAREHOUSE</div>
                          <div style={valueDetailStyle}>
                            {values?.warehouse_name || '-'}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={6}>
                      <div className="d-flex align-items-center w-100">
                        <div
                          className="rounded bg-light d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: '48px',
                            height: '48px',
                            minWidth: '48px'
                          }}
                        >
                          <ClipboardList size={20} className="text-secondary" />
                        </div>
                        <div className="w-100">
                          <div style={labelDetailStyle}>NOTE</div>
                          {data?.status === 'finished' ? (
                            <div style={valueDetailStyle}>
                              {values?.notes || '-'}
                            </div>
                          ) : (
                            <TextField
                              label=""
                              name="notes"
                              value={values?.notes || ''}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              col={12}
                              placeholder="Add a note..."
                              style={{ marginTop: '0' }}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card>

                <Card style={cardStyle}>
                  <h5
                    className="mb-3 text-secondary fw-bold"
                    style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}
                  >
                    Items ({values?.items?.length || 0})
                  </h5>
                  <Table
                    responsive
                    hover
                    className="shadow-sm mb-0 bg-white"
                    size="sm"
                    style={{
                      fontSize: '14px',
                      borderRadius: '12px',
                      overflow: 'hidden'
                    }}
                  >
                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                      <tr>
                        {columns.map((column) => (
                          <th
                            className={`p-2 align-middle ${column.className}`}
                            key={column.key}
                            style={tableHeaderStyle}
                          >
                            {column.key !== 'checkbox' && (
                              <span>{column.label}</span>
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {!values?.items?.length && (
                        <RowEmpty colSpan={columns.length} />
                      )}
                      {values?.items?.length > 0 &&
                        values?.items?.map((item, index) => (
                          <tr
                            key={index}
                            style={{ borderBottom: '1px solid #f0f0f0' }}
                          >
                            {columns.map((column) => (
                              <td
                                key={column.key}
                                className={`p-2 align-middle ${column.className}`}
                              >
                                {column.key === 'sequence' && index + 1}
                                {column.key === 'checked_pack' && (
                                  <div
                                    key={item.id}
                                    className="d-flex justify-content-end"
                                  >
                                    {data?.status !== 'finished' && (
                                      <Form.Control
                                        type="number"
                                        min={0}
                                        className="w-50"
                                        value={item.checked_pack || null}
                                        onChange={(e) => {
                                          setFieldValue(
                                            'items',
                                            values?.items?.map((value) => {
                                              if (value.id === item.id) {
                                                return {
                                                  ...value,
                                                  checked_pack: Number(
                                                    e?.target?.value || null
                                                  ),
                                                  status:
                                                    Number(value.total_pack) ===
                                                    Number(e?.target?.value)
                                                      ? 'match'
                                                      : e?.target?.value ===
                                                            '' ||
                                                          !e?.target?.value
                                                        ? null
                                                        : 'not_match'
                                                }
                                              }
                                              return value
                                            })
                                          )
                                        }}
                                      />
                                    )}
                                    {data?.status === 'finished' &&
                                      item.checked_pack}
                                  </div>
                                )}
                                {column.component && column.component(item)}
                                {![
                                  'action',
                                  'checkbox',
                                  'sequence',
                                  'checked_pack'
                                ].includes(column.key) &&
                                  !column.component &&
                                  item[column.key]}
                              </td>
                            ))}
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </Card>

                {data?.status !== 'finished' && (
                  <div className="d-flex gap-2 justify-content-end mt-3">
                    <Button
                      type="button"
                      variant="transparent"
                      className={`${
                        isValid &&
                        !loading.submit &&
                        values?.items?.every(
                          (item) =>
                            !['', 0, null, undefined].includes(
                              item.checked_pack
                            )
                        )
                          ? 'btn-primary-blue'
                          : 'btn-secondary opacity-25'
                      }`}
                      disabled={
                        !isValid ||
                        loading.submit ||
                        values?.items?.some((item) =>
                          ['', 0, null, undefined].includes(item.checked_pack)
                        )
                      }
                      onClick={(e) => {
                        e.preventDefault()
                        setIsSubmit(true)
                        setVisible(true)
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      type="submit"
                      variant="transparent"
                      className={`${
                        isValid && !loading.submit
                          ? 'btn-primary-orange'
                          : 'btn-secondary opacity-25'
                      }`}
                      disabled={!isValid || loading.submit}
                    >
                      Save
                    </Button>
                  </div>
                )}
              </Form>
            )
          }}
        </Formik>
      </Row>
      <ModalStockAdjustment
        show={visible}
        onHide={handleCloseModal}
        title=""
        size="md"
      >
        <div className="p-2 mt-3 text-center">
          <div className="d-flex justify-content-center">
            <svg
              width="181"
              height="180"
              viewBox="0 0 181 180"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                fill="#828282"
              />
              <path
                d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                fill="#828282"
              />
            </svg>
          </div>
          <div className="my-3">
            <h6>Submitted Ticket?</h6>
            <p>Make sure all data is correct!</p>
          </div>
          <Modal.Footer className="mt-4">
            <div className="d-flex flex-column align-items-end justify-content-end h-100 mt-3">
              <div className="d-flex gap-2">
                <Button variant="transparent" onClick={handleCloseModal}>
                  Cancel
                </Button>
                <Button
                  className={`${
                    loading.submit
                      ? 'btn-secondary opacity-25'
                      : 'btn-primary-orange'
                  }`}
                  onClick={() => formikRef.current?.submitForm()}
                  disabled={loading.submit}
                >
                  {loading.submit ? 'Submitting...' : 'Submit'}
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </ModalStockAdjustment>
    </Container>
  )
}
export default StockOpnamePackingDetail
